const tableNameOrder = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base",
});

// Compare display names without spacing differences ("T 8" and "T8").
// Keep the stored names unchanged: bills and orders use them as identifiers.
const tableSortKey = (name) => String(name ?? "").replace(/\s+/g, "");

export const compareTableNames = (left, right) =>
  tableNameOrder.compare(tableSortKey(left), tableSortKey(right));
